<template>
  <div class="kt-grid kt-grid--ver kt-grid--root kt-page">
    <div id="kt_login" class="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1">
      <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
        <!--begin::Aside-->
        <div
          class="bg-img kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
        >
          <div class="kt-grid__item">
            <router-link to="/" class="kt-login__logo">
              <!-- <img src="/assets/media/logos/logo-4.png"> -->
              <img
                src="../../public/assets/media/icons/eli-logo-white.svg"
                class="logo"
                @click="trackCustomEvent({ action: 'clicked', target: 'logo_register_page', linkTo: 'login' })"
              >
            </router-link>
          </div>
          <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver" style="justify-content: center;">
            <div class="kt-grid__item kt-grid__item--middle">
              <h6 class="kt-font-bold kt-shape-font-color-1 kt-margin-b-10">
                Empower Language Intelligence
              </h6>
              <h3 class="kt-login__title kt-font-bold">
                Understand texts like human do
              </h3>
              <h4 class="kt-login__subtitle kt-font-bold">
                Thai Natural Language Processing Platform
              </h4>
              <a
                href="https://demo.nlp.insightera.co.th/getstart"
                target="_blank"
                class="kt-menu__link "
                @click="trackCustomEvent({ action: 'clicked', target: 'get_started_register_page', linkTo: 'getstart' })"
              >
                <button type="button" class="btn btn-brand">Get started</button>
              </a>
            </div>
          </div>
          <div class="kt-grid__item">
            <div class="kt-login__info">
              <div class="kt-login__copyright">
                2019 © ELI
              </div>
              <div class="kt-login__menu">
                <router-link to="/terms" class="kt-link">
                  <span @click="trackCustomEvent({ action: 'clicked', target: 'terms_register_page', linkTo: 'terms' })">
                    Terms
                  </span>
                </router-link>
                <router-link to="/privacypolicy" class="kt-link">
                  <span @click="trackCustomEvent({ action: 'clicked', target: 'privacy_policy_register_page', linkTo: 'privacypolicy' })">
                    Privacy Policy
                  </span>
                </router-link>
              </div>
            </div>
          </div>
        </div>

        <!--begin::Aside-->

        <!--begin::Content-->
        <div class="kt-grid__item kt-grid__item--fluid kt-grid__item--order-tablet-and-mobile-1 kt-login__wrapper">
          <!--begin::Head-->
          <div class="kt-login__head">
            <span class="signup-msg kt-margin-r-10">Already have an account?</span>&nbsp;&nbsp;
            <!-- <a href="/register" class="kt-link kt-login__signup-link">Sign Up</a> -->
            <router-link to="/login">
              <button
                type="button"
                class="btn btn-outline-brand"
                @click="trackCustomEvent({ action: 'clicked', target: 'sign_in_register_page', linkTo: 'login' })"
              >
                <span class="kt-font-bold">Sign in</span>
              </button>
            </router-link>
          </div>

          <!--end::Head-->

          <!--begin::Body-->
          <div class="kt-login__body">
            <!--begin::Signin-->
            <div class="kt-login__form">
              <div class="kt-align-left kt-margin-b-30">
                <h2>Create your account</h2>
              </div>

              <!--begin::Form-->

              <form ref="form">
                <b-form-group :state="isFullnameValid" label="Full name" label-for="full-name-input" :invalid-feedback="isFullnameInvalidFeedback">
                  <b-form-input
                    id="full-name-input"
                    v-model="fullname"
                    :state="checkFullnameState"
                    @input="trackCustomEvent({ event:'input', action: 'type', target: 'input_box_register_page', value: fullname })"
                  />
                </b-form-group>

                <b-form-group :state="isEmailValid" label="Email" label-for="email-input" :invalid-feedback="isEmailInvalidFeedback">
                  <b-form-input
                    id="email-input"
                    v-model="email"
                    :state="checkEmailState"
                    @input="trackCustomEvent({ event:'input', action: 'type', target: 'input_box_register_page', value: email })"
                  />
                </b-form-group>

                <b-form-group :state="isPassword1Valid" label="Password" label-for="password-input" :invalid-feedback="isPassword1InvalidFeedback">
                  <b-form-input
                    id="password-input"
                    v-model="password1"
                    :state="checkPassword1State"
                    type="password"
                    @input="trackCustomEvent({ event:'input', action: 'type', target: 'input_box_register_page' })"
                  />
                </b-form-group>

                <b-form-group :state="isPassword2Valid" label="Confirm Password" label-for="confirm-password-input" :invalid-feedback="isPassword2InvalidFeedback">
                  <b-form-input
                    id="confirm-password-input"
                    v-model="password2"
                    :state="checkPassword2State"
                    type="password"
                    @input="trackCustomEvent({ event:'input', action: 'type', target: 'input_box_register_page' })"
                  />
                </b-form-group>

                <div v-if="registerResult.status === 'fail'" class="alert alert-solid-danger alert-bold" role="alert">
                  <div class="alert-text">
                    {{ registerResult.message }}
                  </div>
                </div>
                <!-- <div v-if="registerResult.status === 'success'" class="alert alert-solid-success alert-bold" role="alert">
                  <div class="alert-text">
                    {{ registerResult.message }}
                  </div>
                </div> -->
                <div class="kt-login__actions">
                  <button
                    id="kt_login_signin_submit"
                    class="btn btn-brand btn-wide btn-tall kt-block-center"
                    :class="{ 'kt-spinner kt-spinner--md kt-spinner--light': isLoading }"
                    :disabled="!validInput"
                    @click="trackCustomEvent({ action: 'clicked', target: 'sign_up_register_page' }); register($event)"
                  >
                    Sign up
                  </button>
                </div>
                <div v-if="registerResult.status === 'success'" class="alert alert-solid-success alert-bold" role="alert">
                  <div class="alert-text">
                    {{ registerResult.message }}
                  </div>
                </div>
                <div v-if="registerResult.status === 'success'" class="alert alert-solid-success alert-bold" role="alert">
                  <div class="alert-text">
                    please check the verification link on your email for validation
                  </div>
                </div>
              </form>
              <!--end::Form-->
            </div>

            <!--end::Signin-->
          </div>

          <!--end::Body-->
        </div>

        <!--end::Content-->
      </div>
    </div>
  </div>
</template>

<script>
import { BFormInput, BFormGroup } from 'bootstrap-vue'
import { mapActions } from 'vuex'
import util from '../utils'

export default {
  components: {
    'b-form-group': BFormGroup,
    'b-form-input': BFormInput
  },
  data () {
    return {
      fullname: '',
      email: '',
      password1: '',
      password2: '',
      registerResult: {
        status: 'wait',
        message: ''
      },
      isFullnameChanged: false,
      isEmailChanged: false,
      isPassword1Changed: false,
      isPassword2Changed: false,
      isLoading: false,
      emailState: null
    }
  },
  computed: {
    isFullnameValid () {
      return this.fullname.trim().length !== 0
    },
    isEmailValid () {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(this.email).toLowerCase())
    },
    isPassword1Valid () {
      return this.password1.length >= 6
    },
    isPassword2Valid () {
      return this.password1.length >= 6 && this.password1 === this.password2
    },
    isFullnameInvalidFeedback () {
      if (!this.isFullnameValid && !this.isFullnameChanged) {
        return ''
      } else {
        return 'Full name is required'
      }
    },
    isEmailInvalidFeedback () {
      if (!this.isEmailValid && !this.isEmailChanged) {
        return ''
      } else if (!this.isEmailValid && this.email.length !== 0) {
        return 'This email is invalid'
      } else {
        return this.emailState !== false ? 'Email is required' : ''
      }
    },
    isPassword1InvalidFeedback () {
      if (!this.isPassword1Valid && !this.isPassword1Changed) {
        return ''
      } else {
        return 'Passwords must contain at least 6 characters'
      }
    },
    isPassword2InvalidFeedback () {
      if (!this.isPassword2Valid && !this.isPassword2Changed) {
        return ''
      } else if (!this.isPassword2Valid && this.password2.length !== 0) {
        return 'The password does not match'
      } else {
        return 'Passwords must contain at least 6 characters'
      }
    },
    validInput () {
      return this.isFullnameValid && this.isEmailValid && this.isPassword1Valid && this.isPassword2Valid
    },
    checkFullnameState () {
      if (!this.isFullnameValid && this.isFullnameChanged) {
        return false
      } else {
        return null
      }
    },
    checkEmailState () {
      if ((!this.isEmailValid && this.isEmailChanged) || this.emailState === false) {
        return false
      } else {
        return null
      }
    },
    checkPassword1State () {
      if (!this.isPassword1Valid && this.isPassword1Changed) {
        return false
      } else {
        return null
      }
    },
    checkPassword2State () {
      if (!this.isPassword2Valid && this.isPassword2Changed) {
        return false
      } else {
        return null
      }
    }
  },
  watch: {
    fullname () {
      this.isFullnameChanged = true
    },
    email () {
      this.isEmailChanged = true
      this.emailState = null
    },
    password1 () {
      this.isPassword1Changed = true
    },
    password2 () {
      this.isPassword2Changed = true
    }
  },
  mounted () {

  },
  methods: {
    ...mapActions({
      registerRequest: 'user/register',
      trackCustomEvent: 'user/trackCustomEvent'
    }),
    async register (e) {
      e.preventDefault()
      this.registerResult.status = 'wait'
      this.isLoading = true

      const registerResult = await this.registerRequest({
        name: this.fullname,
        email: this.email,
        password: this.password1
      })
      // await util.sleep(500) // FIXME: simulate delay
      this.isLoading = false

      if (registerResult) {
        this.registerResult.status = 'success'
        // this.registerResult.message = 'Register successfully'
        this.registerResult.message = 'Thanks for signing up for ELI!'

        await util.sleep(5000) // show login result a bit then go on
        this.$router.push({ path: '/login' })
      } else {
        this.emailState = false
        this.registerResult.status = 'fail'
        this.registerResult.message = 'Register failed, this email is already taken'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../public/assets/css/pages/login/login-1.css';
.bg-img {
  background: url(../../public/assets/media/bg/ai.jpg) rgba(36, 40, 56, 0.65);
  background-size:cover;
  background-blend-mode: normal;
}
.logo {
  height: 40px;
}
.kt-login__wrapper {
  display: flex;
  flex-direction: column;
}
.kt-login.kt-login--v1 .kt-login__aside .kt-login__title {
    font-size: 24px;
    margin-block-start: 0.67em;
    margin-block-end: 0.67em;
}
.kt-login.kt-login--v1 .kt-login__aside {
    width: initial;
    text-align: center;
}
.kt-login__subtitle.author {
  text-align: right;
  padding-right: 1em;
  margin-top: 0 !important;
}
.kt-login__subtitle.quote {
  font-style: italic;
  margin: 3.5rem 0 1.5rem 0 !important;
}
.signup-msg {
  font-size: 14px;
}
</style>
